import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

export default function Modal({
  isOpen,
  onClose,
  children,
  position = "center",
  maxWidth = ""
}) {
  // Stato per animazione
  const [showModal, setShowModal] = useState(isOpen);

  useEffect(() => {
    setShowModal(isOpen);
  }, [isOpen]);

  if (!isOpen && !showModal) return null;

  const handleClose = () => {
    setShowModal(false);
    setTimeout(onClose, 300);
  };

  // Overlay con posizione
  const overlayClasses =
    position === "center"
      ? "fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
      : "fixed inset-0 flex items-start justify-center pt-10 bg-gray-900 bg-opacity-50 z-50";

  // Classe per larghezza: pieno fino a maxWidth
  const sizeClass = `w-fit `;

  const modalContent = (
    <div className={overlayClasses} onClick={handleClose}>
      <div
        className={` ${sizeClass} transition-all duration-300 transform ${showModal ? "opacity-100 scale-100" : "opacity-0 scale-95"
          }  rounded-lg shadow-lg`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-gray-700">{children}</div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    modalContent,
    document.getElementById("portal-root")
  );
}
